module.exports = __webpack_public_path__ + "c42e9428ac3f8a9a3a0489df0fa61e88.MP3";